import React from 'react';
import { ProductsHero } from '../ProductsHero';
import { ProductsSection } from '../ProductsSection';
import { FlourSpotlight } from '../FlourSpotlight';
import { VisualShowcase } from '../VisualShowcase';
import { TextureCloseup } from '../TextureCloseup';
import { SectionLink } from '../SectionLink';

/**
 * Products page — opens with the same full-bleed hero as home (the board
 * shot), then the three forms the one
 * recipe arrives in, then the flour's own block (the reason this page exists),
 * then where TrueNooch lives and the texture proof.
 *
 * Replaces the never-routed ProductPage.tsx (dead code, 2026-09-03) and the
 * boxed RoundBanner opener (removed 2026-09-04 — did not match the site).
 */
export function ProductsPage() {
  return (
    <>
      <ProductsHero />
      <ProductsSection />
      <FlourSpotlight />
      <VisualShowcase />
      <TextureCloseup />
      <section className="section fade-in" style={{ paddingTop: '1rem', paddingBottom: '4rem' }}>
        <SectionLink to="/recipes">Cook with it</SectionLink>
      </section>
    </>
  );
}
